import { call, put, all, takeEvery } from "redux-saga/effects";
import {
  PURCHASE_DRAFT_LIST,
  PURCHASE_DRAFT_SEARCH,
  PURCHASE_DRAFT_DATA,
  PURCHASE_DRAFT_CREATE,
  PURCHASE_DRAFT_UPDATE,
  PURCHASE_DRAFT_DELETE,
  PURCHASE_DRAFT_CONVERT_TO_PURCHASE,
  PURCHASE_DRAFT_STATUS_LIST,
  PURCHASE_DRAFT_STATUS_DATA,
  PURCHASE_DRAFT_STATUS_CREATE,
  PURCHASE_DRAFT_STATUS_UPDATE,
  PURCHASE_DRAFT_STATUS_DELETE,
} from "./actionType";

import {
  getPurchaseDraftListSuccess,
  getPurchaseDraftListFailure,
  getPurchaseDraftSearchSuccess,
  getPurchaseDraftSearchFailure,
  getPurchaseDraftDataSuccess,
  getPurchaseDraftDataFailure,
  createPurchaseDraftSuccess,
  createPurchaseDraftFailure,
  updatePurchaseDraftSuccess,
  updatePurchaseDraftFailure,
  deletePurchaseDraftSuccess,
  deletePurchaseDraftFailure,
  convertToPurchaseSuccess,
  convertToPurchaseFailure,
  getPurchaseDraftStatusListSuccess,
  getPurchaseDraftStatusListFailure,
  getPurchaseDraftStatusDataSuccess,
  getPurchaseDraftStatusDataFailure,
  createPurchaseDraftStatusSuccess,
  createPurchaseDraftStatusFailure,
  updatePurchaseDraftStatusSuccess,
  updatePurchaseDraftStatusFailure,
  deletePurchaseDraftStatusSuccess,
  deletePurchaseDraftStatusFailure,
} from "./action";

import {
  getPurchaseDraftListApi,
  getPurchaseDraftSearchApi,
  getPurchaseDraftDataApi,
  createPurchaseDraftApi,
  updatePurchaseDraftApi,
  deletePurchaseDraftApi,
  convertToPurchaseApi,
  getPurchaseDraftStatusListApi,
  getPurchaseDraftStatusDataApi,
  createPurchaseDraftStatusApi,
  updatePurchaseDraftStatusApi,
  deletePurchaseDraftStatusApi,
} from "../../helpers/fakebackend_helper";

// PURCHASE_DRAFT_LIST
function* getPurchaseDraftList() {
  try {
    const response = yield call(getPurchaseDraftListApi);
    yield put(getPurchaseDraftListSuccess(response));
  } catch (error) {
    yield put(getPurchaseDraftListFailure(error));
  }
}
// Watcher Saga
function* watchGetPurchaseDraftList() {
  yield takeEvery(PURCHASE_DRAFT_LIST, getPurchaseDraftList);
}
// PURCHASE_DRAFT_SEARCH
function* getPurchaseDraftSearch({ payload }) {
  try {
    const response = yield call(getPurchaseDraftSearchApi, payload);
    yield put(getPurchaseDraftSearchSuccess(response));
  } catch (error) {
    yield put(getPurchaseDraftSearchFailure(error));
  }
}
// Watcher Saga
function* watchGetPurchaseDraftSearch() {
  yield takeEvery(PURCHASE_DRAFT_SEARCH, getPurchaseDraftSearch);
}
// PURCHASE_DRAFT_DATA
function* getPurchaseDraftData({ payload }) {
  try {
    const response = yield call(getPurchaseDraftDataApi, payload);
    yield put(getPurchaseDraftDataSuccess(response));
  } catch (error) {
    yield put(getPurchaseDraftDataFailure(error));
  }
}
// Watcher Saga
function* watchGetPurchaseDraftData() {
  yield takeEvery(PURCHASE_DRAFT_DATA, getPurchaseDraftData);
}
// PURCHASE_DRAFT_CREATE
function* createPurchaseDraft({ payload }) {
  try {
    const response = yield call(createPurchaseDraftApi, payload);
    yield put(createPurchaseDraftSuccess(response));
  } catch (error) {
    yield put(createPurchaseDraftFailure(error));
  }
}
// Watcher Saga
function* watchCreatePurchaseDraft() {
  yield takeEvery(PURCHASE_DRAFT_CREATE, createPurchaseDraft);
}
// PURCHASE_DRAFT_UPDATE
function* updatePurchaseDraft({ payload }) {
  try {
    const response = yield call(updatePurchaseDraftApi, payload);
    yield put(updatePurchaseDraftSuccess(response));
  } catch (error) {
    yield put(updatePurchaseDraftFailure(error));
  }
}
// Watcher Saga
function* watchUpdatePurchaseDraft() {
  yield takeEvery(PURCHASE_DRAFT_UPDATE, updatePurchaseDraft);
}
// PURCHASE_DRAFT_DELETE
function* deletePurchaseDraft({ payload }) {
  try {
    const response = yield call(deletePurchaseDraftApi, payload);
    yield put(deletePurchaseDraftSuccess(response));
  } catch (error) {
    yield put(deletePurchaseDraftFailure(error));
  }
}
// Watcher Saga
function* watchDeletePurchaseDraft() {
  yield takeEvery(PURCHASE_DRAFT_DELETE, deletePurchaseDraft);
}
// PURCHASE_DRAFT_CONVERT_TO_PURCHASE
function* convertToPurchase({ payload }) {
  try {
    const response = yield call(convertToPurchaseApi, payload);
    yield put(convertToPurchaseSuccess(response));
  } catch (error) {
    yield put(convertToPurchaseFailure(error));
  }
}
// Watcher Saga
function* watchConvertToPurchase() {
  yield takeEvery(PURCHASE_DRAFT_CONVERT_TO_PURCHASE, convertToPurchase);
}
// PURCHASE_DRAFT_STATUS_LIST
function* getPurchaseDraftStatusList() {
  try {
    const response = yield call(getPurchaseDraftStatusListApi);
    yield put(getPurchaseDraftStatusListSuccess(response));
  } catch (error) {
    yield put(getPurchaseDraftStatusListFailure(error));
  }
}
// Watcher Saga
function* watchGetPurchaseDraftStatusList() {
  yield takeEvery(PURCHASE_DRAFT_STATUS_LIST, getPurchaseDraftStatusList);
}
// PURCHASE_DRAFT_STATUS_DATA
function* getPurchaseDraftStatusData({ payload }) {
  try {
    const response = yield call(getPurchaseDraftStatusDataApi, payload);
    yield put(getPurchaseDraftStatusDataSuccess(response));
  } catch (error) {
    yield put(getPurchaseDraftStatusDataFailure(error));
  }
}
// Watcher Saga
function* watchGetPurchaseDraftStatusData() {
  yield takeEvery(PURCHASE_DRAFT_STATUS_DATA, getPurchaseDraftStatusData);
}
// PURCHASE_DRAFT_STATUS_CREATE
function* createPurchaseDraftStatus({ payload }) {
  try {
    const response = yield call(createPurchaseDraftStatusApi, payload);
    yield put(createPurchaseDraftStatusSuccess(response));
  } catch (error) {
    yield put(createPurchaseDraftStatusFailure(error));
  }
}
// Watcher Saga
function* watchCreatePurchaseDraftStatus() {
  yield takeEvery(PURCHASE_DRAFT_STATUS_CREATE, createPurchaseDraftStatus);
}
// PURCHASE_DRAFT_STATUS_UPDATE
function* updatePurchaseDraftStatus({ payload }) {
  try {
    const response = yield call(updatePurchaseDraftStatusApi, payload);
    yield put(updatePurchaseDraftStatusSuccess(response));
  } catch (error) {
    yield put(updatePurchaseDraftStatusFailure(error));
  }
}
// Watcher Saga
function* watchUpdatePurchaseDraftStatus() {
  yield takeEvery(PURCHASE_DRAFT_STATUS_UPDATE, updatePurchaseDraftStatus);
}
// PURCHASE_DRAFT_STATUS_DELETE
function* deletePurchaseDraftStatus({ payload }) {
  try {
    const response = yield call(deletePurchaseDraftStatusApi, payload);
    yield put(deletePurchaseDraftStatusSuccess(response));
  } catch (error) {
    yield put(deletePurchaseDraftStatusFailure(error));
  }
}
// Watcher Saga
function* watchDeletePurchaseDraftStatus() {
  yield takeEvery(PURCHASE_DRAFT_STATUS_DELETE, deletePurchaseDraftStatus);
}
// Root Saga
export default function* PurchaseDraft() {
  yield all([
    watchGetPurchaseDraftList(),
    watchGetPurchaseDraftSearch(),
    watchGetPurchaseDraftData(),
    watchCreatePurchaseDraft(),
    watchUpdatePurchaseDraft(),
    watchDeletePurchaseDraft(),
    watchConvertToPurchase(),
    watchGetPurchaseDraftStatusList(),
    watchGetPurchaseDraftStatusData(),
    watchCreatePurchaseDraftStatus(),
    watchUpdatePurchaseDraftStatus(),
    watchDeletePurchaseDraftStatus(),
  ]);
}
